const LOGIN_EMAIL_BLURRED = 'LOGIN_EMAIL_BLURRED';
const LOGIN_EMAIL_FOCUSED = 'LOGIN_EMAIL_FOCUSED';
const LOGIN_EMAIL_SET = 'LOGIN_EMAIL_SET';
const LOGIN_EMAIL_CHANGE = 'LOGIN_EMAIL_CHANGE';
const LOGIN_EMAIL_SET_FOCUS = 'LOGIN_EMAIL_SET_FOCUS';
const LOGIN_EMAIL_SET_VALIDATION_MESSAGE = 'LOGIN_EMAIL_SET_VALIDATION_MESSAGE';
const LOGIN_EMAIL_SET_VISUALIZATION = 'LOGIN_EMAIL_SET_VISUALIZATION';
const LOGIN_EMAIL_TOGGLE_DISABLED = 'LOGIN_EMAIL_TOGGLE_DISABLED';

const loginEmailSet = (email) => ({
  type: LOGIN_EMAIL_SET,
  payload: email
});

const loginEmailSetFocus = (focused) => ({
  type: LOGIN_EMAIL_SET_FOCUS,
  payload: focused
});

const loginEmailSetValidationMessage = (validationMessage) => ({
  type: LOGIN_EMAIL_SET_VALIDATION_MESSAGE,
  payload: validationMessage
});

const loginEmailSetVisualization = (visualized) => ({
  type: LOGIN_EMAIL_SET_VISUALIZATION,
  payload: visualized
});

const loginEmailBlur = (markedAsWrong, validationMessage) => ({
  type: LOGIN_EMAIL_BLURRED,
  payload: { markedAsWrong, validationMessage }
});

const loginEmailFocus = () => ({
  type: LOGIN_EMAIL_FOCUSED
});

const loginEmailChange = (payload) => ({
  type: LOGIN_EMAIL_CHANGE,
  payload
});

const loginEmailDisable = () => ({
  type: LOGIN_EMAIL_TOGGLE_DISABLED
});


export {
  LOGIN_EMAIL_SET,
  LOGIN_EMAIL_CHANGE,
  LOGIN_EMAIL_SET_VALIDATION_MESSAGE,
  LOGIN_EMAIL_SET_VISUALIZATION,
  LOGIN_EMAIL_SET_FOCUS,
  LOGIN_EMAIL_BLURRED,
  LOGIN_EMAIL_FOCUSED,
  LOGIN_EMAIL_TOGGLE_DISABLED,
  loginEmailDisable,
  loginEmailBlur,
  loginEmailFocus,
  loginEmailSet,
  loginEmailChange,
  loginEmailSetVisualization,
  loginEmailSetValidationMessage,
  loginEmailSetFocus
};
